<template>
  <div
    class="block block-fx-pop block-mode-loading-oneui"
    :class="{ 'block-mode-loading': loading }"
    v-if="!$_.isEmpty(group.links) && filteredLinks.length > 0"
  >
    <!-- v-show="!called || (called && links.length > 0)"> -->
    <div class="block-header block-header-default">
      <h3 class="block-title">
        {{ group.package.name }}
      </h3>
      <div class="block-options">
        <button
          type="button"
          class="btn btn-sm btn-danger ml-2"
          v-if="group.links[group.links.length - 1].status === 'Verlopen'"
          v-on:click="bulkDelete(group)"
          data-toggle="tooltip"
          data-placement="top"
          title="Verwijder linkpakket"
          data-original-title="Verwijder linkpakket"
        >
          <i class="fa fa-fw fa-trash"></i>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-success ml-2"
          :disabled="inCart(group.links[0])"
          v-on:click="importCart(group)"
          data-toggle="tooltip"
          data-placement="top"
          title="Toevoegen aan winkelwagen"
          data-original-title="Toevoegen aan winkelwagen"
        >
          <i v-if="!group.links[0].cartItem" class="fas fa-cart-plus"></i>
          <i v-if="group.links[0].cartItem" class="fa fa-fw fa-check"></i>
        </button>
      </div>
    </div>
    <div class="block-content">
      <p v-if="filteredLinks.length === 0">Geen links gevonden!</p>
      <table class="table table-sm table-hover table-vcenter" v-if="filteredLinks.length > 0">
        <thead>
          <tr>
            <th style="width: 130px" class="d-none d-sm-table-cell">Website</th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Pagina</th>
            <th>Titel / Url</th>
            <th style="width: 130px" class="d-none d-xl-table-cell">Startdatum</th>
            <th style="width: 130px" class="d-none d-md-table-cell">Vervaldatum</th>
            <th style="width: 130px" class="d-none d-sm-table-cell">Status</th>
            <th style="width: 80px" class="text-center">Acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="link in filteredLinks" :key="`${link.site.id}-${link.id}`">
            <td class="d-none d-sm-table-cell">{{ link.site.name }}</td>
            <td class="d-none d-sm-table-cell">{{ link.category.page.title }}</td>
            <td class="font-size-sm">
              <p class="font-w600 mb-1 text-truncate">
                {{ link.title | capitalize }}
              </p>
              <p class="text-muted mb-0 text-truncate">
                {{ link.url }}
              </p>
            </td>
            <td class="d-none d-xl-table-cell">{{ link.started_at ? moment(link.started_at).format('DD-MM-YYYY') : 'n.v.t.' }}</td>
            <td class="d-none d-md-table-cell">{{ link.expired_at ? moment(link.expired_at).format('DD-MM-YYYY') : 'n.v.t.' }}</td>
            <td class="d-none d-sm-table-cell" :class="statusclass(link)">{{ link.status_name }}</td>
            <td class="text-center">
              <a
                :href="$route('links.edit', link.site.id, link.id)"
                data-toggle="tooltip"
                data-placement="top"
                title="Link bewerken"
                data-original-title="Link bewerken"
              >
                <i class="fa fa-fw fa-pencil-alt"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Fuse from 'fuse.js';
import moment from 'moment';
import EventBus from '../plugins/vue-event-bus';

export default {
  props: {
    group: {
      required: true,
      default: [],
    },
    selectedFilters: {
      required: true,
      default: [],
    },
    cartItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data: () => {
    return {
      loading: false,
      filteredLinks: [],
    };
  },
  created: function() {
    this.filteredLinks = this.group.links.sort((a, b) => moment(a.expired_at).diff(moment(b.expired_at)));
  },
  mounted: function() {
    setTimeout(() => {
      window.One.helpers(['core-bootstrap-tooltip']);
    }, 500);
  },
  watch: {
    selectedFilters: function() {
      this.applyFilters();
      setTimeout(() => {
        window.One.helpers(['core-bootstrap-tooltip']);
      }, 100);
    },
  },
  methods: {
    statusclass(link) {
      switch (link.status) {
        case 2:
          return 'text-danger';
          break;

        default:
          return '';
          break;
      }
    },
    applyFilters() {
      let links = this.group.links;
      let combinedFilters = [];
      this.selectedFilters
        .filter((selectedFilter) => !['package', 'status_name'].includes(selectedFilter.key))
        .forEach((selectedFilter) => {
          var index = _.findIndex(combinedFilters, (cFilter) => {
            return cFilter.key === selectedFilter.key;
          });

          if (index >= 0) {
            combinedFilters[index].values.push(selectedFilter.value);
          } else {
            combinedFilters.push({
              key: selectedFilter.key,
              values: [selectedFilter.value],
            });
          }
        });

      combinedFilters
        .filter((selectedFilter) => selectedFilter.key !== 'search')
        .forEach((filter) => {
          links = links.filter((link) => {
            return link[filter.key] && filter.values.includes(link[filter.key]);
          });
        });

      this.filteredLinks = links;
      this.applySearch(combinedFilters);
    },
    applySearch(combinedFilters) {
      var fuse = new Fuse(this.filteredLinks, {
        threshold: 0.2,
        includeScore: false,
        useExtendedSearch: true,
        keys: ['title', 'url', 'category.page.title'],
      });
      combinedFilters
        .filter((selectedFilter) => selectedFilter.key === 'search')
        .forEach((filter) => {
          this.filteredLinks = fuse.search(filter.values.join('|')).map((result) => {
            return result.item;
          });
        });
    },
    inCart: function(link) {
      link.cartItem = this.cartItems.find((item) => {
        return item.site && item.site.id === link.site.id && item.link_id === link.id;
      });
      return link.cartItem;
    },
    importCart(group) {
      this.loading = true;
      axios
        .post(route('cart.import'), {
          links: group.links.map((link) => {
            return {
              site_id: link.site.id,
              link_id: link.id,
              page_id: link.category.page.id,
              category_id: link.category.id,
              title: link.title,
              url: link.url,
              description: link.description,
              follow: link.follow,
              period: 1,
              user_package_id: link.user_package_id,
              start_date: moment(link.expired_at).format('YYYY-MM-DD'),
            };
          }),
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              EventBus.publish('cart.refresh');

              this.$notify({
                group: 'main',
                type: 'success',
                title: `Linkpakket ${group.package.name} is toegevoegd en staat in de winkelwagen klaar voor betaling`,
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    bulkDelete(group) {
      this.loading = true;
      axios
        .post(route('links.bulk-delete'), {
          links: group.links.map((link) => {
            return {
              site_id: link.site.id,
              link_id: link.id,
            };
          }),
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              this.$notify({
                group: 'main',
                type: 'success',
                title: `Linkpakket ${group.package.name} is verwijdert`,
              });

              window.location.reload();
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}

.block {
  .block-header {
    .block-title {
      i {
        transition: transform 0.15s ease;
      }
      &.js-class-toggle-toggled {
        i {
          transform: rotate(180deg);
        }
      }
    }
  }
}

table {
  table-layout: fixed;
}
</style>
